/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable class-methods-use-this */

import * as Services from '@services';
import { EntityDto, RequestDto, RequestedRequest } from '@services';
import { makeAutoObservable, runInAction } from 'mobx';

class RequestStore {
  documentSasUrl: string = '';
  requests = new Map<string, RequestedRequest>();
  skipCount: number = 0;
  maxResultCount: number = 5;
  request!: RequestDto | undefined;
  totalCount: number = 0;
  currentPage: number = 1;
  loading: boolean = false;
  countloading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getAll(filter: Services.PagedRequestDto) {
    this.setLoading(true);
    try {
      const result = await Services.RequestService.getAll(filter);
      runInAction(() => {
        this.requests.clear();
        result.items.forEach((request) => {
          this.requests.set(request.id, request);
        });
        this.totalCount = result.totalCount;
      });
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  async getTotalCount(status: string) {
    this.setCountLoading(true);
    try {
      const response = await Services.RequestService.getTotalCount(status);

      runInAction(() => {
        this.totalCount = response;
      });
      this.setCountLoading(false);
    } catch (error) {
      this.setCountLoading(false);
      console.error(error);
    }
  }

  async update(request: Services.UpdateRequest) {
    const result = await Services.RequestService.update(request);
    runInAction(() => {
      this.request = result;
    });
  }

  async get(entityDto: Services.EntityDto<string>) {
    this.setLoading(true);
    try {
      const result = await Services.RequestService.get(entityDto);
      runInAction(() => {
        this.request = result;
      });
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  async delete(id: EntityDto<string>) {
    this.setLoading(true);
    try {
      await Services.RequestService.delete(id);
      await this.filterRequestSidePanel(id.id);
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  filterRequestSidePanel = async (id: string) => {
    const totalCount = this.totalCount;

    runInAction(() => {
      if (this.requests.has(id)) {
        this.requests.delete(id);
        this.totalCount -= 1;
      }
    });

    if (this.requests.size === 0 && this.currentPage > 1) {
      this.setPageChange(this.currentPage - 1);
    }

    const currentCount = this.maxResultCount * this.currentPage;

    if (totalCount <= currentCount || this.totalCount === 0) return;

    await this.getAll({
      skipCount:
        totalCount === this.skipCount + 1 ? this.skipCount - this.maxResultCount : this.skipCount,
      maxResultCount: this.maxResultCount,
    });
  };

  addRequest = (request: RequestedRequest) => {
    runInAction(() => {
      this.totalCount += 1;
      if (this.requests.size < 5) {
        this.requests.set(request.id, request);
      }
    });
  };

  setPageChange = (current: number) => {
    runInAction(() => {
      this.skipCount = (current - 1) * this.maxResultCount;
      this.currentPage = current;
    });
  };

  clearTotalCount = () => {
    runInAction(() => {
      this.totalCount = 0;
    });
  };

  setCountLoading = (value: boolean) => {
    runInAction(() => {
      this.countloading = value;
    });
  };

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  clearRequest = () => {
    runInAction(() => {
      this.request = undefined;
    });
  };

  async appendAll(filter: Services.PagedRequestDto) {
    this.setLoading(true);
    try {
      const result = await Services.RequestService.getAll(filter);
      runInAction(() => {
        result.items.forEach((request) => {
          this.requests.set(request.id, request);
        });
        this.totalCount = result.totalCount;
      });
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  clearRequests = () => {
    runInAction(() => {
      this.requests.clear();
    });
  };

  setSkipCount = (value: number) => {
    runInAction(() => {
      this.skipCount = value;
    });
  };
}

export default RequestStore;
